import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { adminAddBlogAction , adminUpdateBlogAction} from '../../../actions/Admin/Blog';
import { uploadResumeFile } from '../../../actions/FindRecCompany';
import NavMenu from '../sidebar/navBar';
import {  Button } from 'reactstrap';
import { notification } from 'antd';
import SideMenu from '../sidebar/SidebarCustom';
import './../App.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
class AdminAddBlog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            imageUpload: false,
            edit: false,
            add: false,
            update: false,
            fieldsList: [],
            code: '',
            fieldSelct: '',
            formData: {},
        }
    }
    componentWillMount() {
        console.log("this.props",this.props)
        if(this.props && this.props.location && this.props.location.state && this.props.location.state._id){
            this.setState({
                formData:this.props.location.state,
                edit:true
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        

        if(nextProps.blog && nextProps.blog.code && nextProps.blog.code === 200 && this.state.add){
            notification.success({
                message: nextProps.blog.msg,
                className:'successNotification',
                duration: 3
            });
            this.setState({
                formData: {},
                add:false
            })
            this.props.history.push({
                pathname: "/admin/blog-list",
            });
        }
        if(nextProps.blogUpdate && nextProps.blogUpdate.code && nextProps.blogUpdate.code === 200 && this.state.update){
            notification.success({
                message: nextProps.blogUpdate.msg,
                className:'successNotification',
                duration: 3
            });
            this.setState({
                formData: {},
                update:false
            })
            this.props.history.push({
                pathname: "/admin/blog-list",
            });
        }
            console.log("nextProps.image",nextProps.image, this.state.imageUpload)
        if (nextProps.image && nextProps.image.statusCode && nextProps.image.statusCode === 200 && this.state.imageUpload) {
            this.setState({
                imageUpload: false
            })
            let formData = this.state.formData
            formData['image'] = nextProps.image.file_name;
            this.setState({
                formData:formData
            })
        }
    }

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    inputchange = (e) => {
        e.preventDefault();
        const { formData } = this.state
        formData[e.target.name] = e.target.value;
        this.setState({
            formData: formData
        })
    }

    changeImage = (e) => {
        e.preventDefault();
        this.setState({
            imageUpload: true
        })
        var file = document.getElementById("file").files[0];
        this.props.uploadResumeFile(file)
    }

    handleSubmit = () => {
        const { formData, edit } = this.state;
        //console.log("formData", formData)
        if (formData !== undefined && formData.name !== "" && !edit) {
            this.setState({
                add:true
            })
            this.props.adminAddBlogAction(this.state.formData)
        } else {
            this.setState({
                update:true
            })
            this.props.adminUpdateBlogAction(this.state.formData)
           // alert("Please define the category name")
        }
    }

    formHandlerTextEditor = (value, field) => {
        const { formData } = this.state;
        formData[field] = value;
        this.setState({
            formData
        })
        if (formData !== undefined && formData.name !== "") {
            // this.props.adminCatgeoryAddAction(this.state.formData)
        } else {
            alert("Please define the category name")
        }
    }

    _quillModules = {
        toolbar: [
            [{
                'header': [1, 2, false]
            }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{
                'list': 'ordered'
            }, {
                'list': 'bullet'
            }, {
                'indent': '-1'
            }, {
                'indent': '+1'
            }],
            ['link', 'image'],
            ['clean']
        ]
    };

    _quillFormats = ["header",
        "bold", "italic", "underline", "strike", "blockquote",
        "list", "bullet", "indent",
        "link", "image"
    ];
    
    render() {
        const { formData, edit } = this.state;
        console.log("formData",formData)
        return (
            <div className="wrapper">
                <SideMenu toggle={this.toggle} isOpen={this.state.isOpen} />
                <div id="content">
                    <NavMenu toggle={this.toggle} isOpen={this.state.isOpen} />
                    <div> <h1 class="main-heading mt-5">{edit ? "Edit Blog" : "Add Blog"}</h1></div>

                    <div className="custom-table-wrapper">
                        <div className="addBlog">
                            <div className="col-md-8">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label md='3' htmlFor="title">Title*</label>
                                            <input md='9' type="text" className="form-control" name="title" id="title" defaultValue={formData.title} onChange={this.inputchange} placeholder="Title" />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label md='3'>Description*</label>
                                            <ReactQuill onChange={e=>
                                                this.formHandlerTextEditor(e,'description')}
                                                value={formData.description || ''}
                                                name="description"
                                                theme='snow'
                                                modules={this._quillModules}
                                                formats={this._quillFormats}
                                                required={true}
                                                toolbar={true} // Let Quill manage toolbar
                                                bounds={'._quill'}
                                                />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label md='3' htmlFor="title">Upload Image</label>
                                            <input type="file" className="box__file" id="file" name="files" onChange={this.changeImage.bind(this)} accept="image" required />
                                            {formData.image &&

                                                <img src={process.env.REACT_APP_SERVER_IMAGE_BUCKET+"/"+formData.image} width="50%" alt="blog"/>
                                            }
                                        </div>
                                    </div>
                                    <Button color="primary" className="pull-right" onClick={e=>this.handleSubmit()}>{edit ? "Update":"Submit"}</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    console.log("State",state)
    return {
        fields: state.home.response.data,
        image: state.FindRecCompany.resume,
        blog: state.AdminBlog.response,
        blogUpdate: state.AdminBlog.responseUpdate
    };
}
export default withRouter(connect(mapStateToProps, {
    adminUpdateBlogAction,
    adminAddBlogAction,
    uploadResumeFile
    //  adminCatgeoryAddAction,
})(AdminAddBlog));


// WEBPACK FOOTER //
// ./src/components/Admin/Blog/Add.js